import styled, { css } from "styled-components";
import { IGateway } from "@grabcad/company-server-shared/dist/types";

type GatewayStatus = IGateway["status"];

const badgeStyles: Record<GatewayStatus, ReturnType<typeof css>> = {
    HEALTHY: css`
        background: #ecfdf3;
        border: 1px solid #abefc6;
    `,
    UNHEALTHY: css`
        background: #fef3c6;
        border: 1px solid #fee685;
    `,
    NEW: css`
        background: #faf5ff;
        border: 1px solid #e9d4ff;
    `,
};

const textStyles: Record<GatewayStatus, ReturnType<typeof css>> = {
    HEALTHY: css`
        color: #067647;
    `,
    UNHEALTHY: css`
        color: #bb4d00;
    `,
    NEW: css`
        color: #8200db;
    `,
};

export const Badge = styled.div<{ status: GatewayStatus }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 10px;

    ${({ status }) => badgeStyles[status]}
`;

export const BadgeIcon = styled.img`
    width: 14px;
    height: 14px;
    display: block;
    flex-shrink: 0;
`;

export const BadgeText = styled.span<{ status: GatewayStatus }>`
    font-size: 12px;
    font-weight: 400;
    line-height: 1;
    display: flex;
    align-items: center;

    ${({ status }) => textStyles[status]}
`;
